/*
  LA Q4 kampanyası (9 Eki 2026) - bar, slayt ve ürün şeridinin ortak sürücüsü.

  Sunucu (Liquid) etkin dönemi 'now' ile seçip basar; bu dosya:
  1. Dönemi tarayıcı saatiyle YENİDEN seçer. Sayfa önbellekten bayat geldiyse
     ya da sayfa açıkken dönem değiştiyse metinleri/renkleri/linkleri günceller.
  2. Geri sayımları çalıştırır, sıfırlanınca bir sonraki döneme geçer.
  3. "Kodu kopyala" düğmeleri.
  4. Ürün sayfasındaki kayan şeritte data-lak-mq öğelerini dönem metniyle doldurur.

  Önizleme testi: ?lak=<dönem id> (ör. ?lak=bf) o dönemin başlangıcını taklit eder.
  Takvim: shop metafield la_kampanya.takvim (repo: kampanya/takvim.json).
*/
(function () {
  if (window.__lak) return;
  window.__lak = true;

  var veriEl = document.querySelector('[data-la-kampanya-veri]');
  if (!veriEl) return;
  var takvim;
  try { takvim = JSON.parse(veriEl.textContent); } catch (e) { return; }
  if (!takvim || !takvim.donemler) return;

  var donemler = takvim.donemler.map(function (d) {
    d._bas = Date.parse(d.bas);
    d._bit = Date.parse(d.bit);
    return d;
  });

  // Test kaydırması: ?lak=<id> ya da ?lak_simdi=<ISO>
  var kaydirma = 0;
  try {
    var q = new URLSearchParams(location.search);
    var testId = q.get('lak');
    var testAn = q.get('lak_simdi');
    var hedef = testAn ? Date.parse(testAn) : null;
    if (testId) {
      var td = donemler.filter(function (d) { return d.id === testId; })[0];
      if (td) hedef = td._bas + 60000;
    }
    if (hedef) kaydirma = hedef - Date.now();
  } catch (e) {}

  function simdi() { return Date.now() + kaydirma; }

  function etkin() {
    var t = simdi();
    for (var i = 0; i < donemler.length; i++) {
      if (t >= donemler[i]._bas && t < donemler[i]._bit) return donemler[i];
    }
    return null;
  }

  var paraBirimi = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var para;
  try {
    para = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: paraBirimi });
  } catch (e) {
    para = { format: function (n) { return '$' + n.toFixed(2); } };
  }

  function indirimLinki(d, yol) {
    var hedef = yol || d.link;
    return d.kod ? '/discount/' + encodeURIComponent(d.kod) + '?redirect=' + encodeURIComponent(hedef) : hedef;
  }

  function goster(el, gorunur) {
    if (gorunur) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
  }

  function doldur(kok, d) {
    var tur = kok.getAttribute('data-lak');

    if (!d) {
      // Kampanya bitti: bar ve şerit kaybolur, slayt yedek içeriğinde kalır
      if (tur === 'bar' || tur === 'urun') goster(kok, false);
      kok.querySelectorAll('[data-lak-sayac], [data-lak-goster]').forEach(function (el) {
        var liste = (el.getAttribute('data-lak-goster') || '').split(' ');
        goster(el, liste.indexOf('yedek') > -1);
      });
      kok.setAttribute('data-lak-donem', '');
      return;
    }

    ['bg', 'fg', 'vurgu', 'chip'].forEach(function (k) {
      if (d.renk && d.renk[k]) kok.style.setProperty('--lak-' + k, d.renk[k]);
    });

    kok.querySelectorAll('[data-lak-f]').forEach(function (el) {
      var alan = el.getAttribute('data-lak-f');
      if (d[alan] !== undefined && d[alan] !== null) el.textContent = d[alan];
    });

    kok.querySelectorAll('[data-lak-href]').forEach(function (el) {
      el.setAttribute('href', indirimLinki(d));
    });

    kok.querySelectorAll('[data-lak-goster]').forEach(function (el) {
      var liste = el.getAttribute('data-lak-goster').split(' ');
      goster(el, liste.indexOf(d.tur) > -1);
    });

    kok.querySelectorAll('[data-lak-kod-kutu]').forEach(function (el) { goster(el, !!d.kod); });
    kok.querySelectorAll('[data-lak-sayac]').forEach(function (el) { goster(el, true); });

    if (tur === 'urun') {
      goster(kok, d.tur === 'satis' || d.tur === 'erken');
      var fiyat = parseInt(kok.getAttribute('data-lak-fiyat'), 10) || 0;
      var yol = kok.getAttribute('data-lak-redirect');
      if (d.oran) {
        var yeni = fiyat - Math.round(fiyat * d.oran / 100);
        var eski = kok.querySelector('[data-lak-eski]');
        var yeniEl = kok.querySelector('[data-lak-yeni]');
        if (eski) eski.textContent = para.format(fiyat / 100);
        if (yeniEl) yeniEl.textContent = para.format(yeni / 100);
      }
      var uygula = kok.querySelector('[data-lak-uygula]');
      if (uygula && d.kod) uygula.setAttribute('href', indirimLinki(d, yol));
    } else if (tur === 'bar') {
      goster(kok, true);
    }

    kok.setAttribute('data-lak-donem', d.id);
    kok.setAttribute('data-lak-tur', d.tur);
  }

  var sonId = null;
  function esitle(zorla) {
    var d = etkin();
    var id = d ? d.id : '';
    if (!zorla && id === sonId) return d;
    sonId = id;
    document.querySelectorAll('[data-lak]').forEach(function (kok) {
      if (zorla || kok.getAttribute('data-lak-donem') !== id) doldur(kok, d);
    });
    document.querySelectorAll('[data-lak-mq]').forEach(function (el) {
      if (!el.hasAttribute('data-lak-mq-yedek')) el.setAttribute('data-lak-mq-yedek', el.textContent);
      var alan = el.getAttribute('data-lak-mq');
      var metin = null;
      if (d && alan === 'mq' && d.mq) metin = d.mq;
      if (d && alan === 'kod' && d.kod) metin = '\u2705 USE CODE: ' + d.kod;
      el.textContent = metin || el.getAttribute('data-lak-mq-yedek');
    });
    document.documentElement.classList.toggle('lak-etkin', !!d);
    if (!d) document.documentElement.style.removeProperty('--announcement-bar-height');
    barYuksekligiSonra();
    return d;
  }

  function etiket(d) {
    if (d.tur === 'satis') return 'Ends in';
    if (d.tur === 'teaser') return 'Starts in';
    if (d.id === 'bf-yakinda') return 'Opens in';
    return 'Black Friday in';
  }

  function iki(n) { return (n < 10 ? '0' : '') + n; }

  function sayaclar(d) {
    var els = document.querySelectorAll('[data-lak-sayac]');
    if (!d) return;
    var kalan = Math.max(0, d._bit - simdi());
    var s = Math.floor(kalan / 1000);
    var g = Math.floor(s / 86400); s -= g * 86400;
    var sa = Math.floor(s / 3600); s -= sa * 3600;
    var dk = Math.floor(s / 60); s -= dk * 60;
    els.forEach(function (el) {
      if (el.classList.contains('lak-sayac--kutu')) {
        el.innerHTML =
          '<span class="lak-sayac__etiket">' + etiket(d) + '</span>' +
          '<span class="lak-sayac__kutular">' +
          '<span><b>' + g + '</b><i>days</i></span>' +
          '<span><b>' + iki(sa) + '</b><i>hrs</i></span>' +
          '<span><b>' + iki(dk) + '</b><i>min</i></span>' +
          '<span><b>' + iki(s) + '</b><i>sec</i></span></span>';
      } else {
        el.textContent = etiket(d) + ' ' + (g ? g + 'd ' : '') + iki(sa) + 'h ' + iki(dk) + 'm ' + iki(s) + 's';
      }
    });
  }

  function kopyala(btn) {
    var kodEl = btn.querySelector('[data-lak-f="kod"], [data-lak-f="erken_kod"]');
    var kod = kodEl ? kodEl.textContent.trim() : '';
    if (!kod) return;
    var durum = btn.querySelector('[data-lak-kopya-durum]');
    function bitti() {
      btn.classList.add('lak-kod--kopyalandi');
      if (durum) durum.textContent = 'Copied!';
      setTimeout(function () {
        btn.classList.remove('lak-kod--kopyalandi');
        if (durum) durum.textContent = 'Tap to copy';
      }, 1800);
    }
    // Pano API'si reddederse (izin, http, eski tarayıcı) eski yönteme düş;
    // o da olmazsa "Copied!" deme, kodu seçili bırak ki elle kopyalansın.
    function eskiYontem() {
      var ta = document.createElement('textarea');
      ta.value = kod; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      if (ok) { bitti(); return; }
      if (kodEl && window.getSelection) {
        var r = document.createRange(); r.selectNodeContents(kodEl);
        var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
      }
      if (durum) durum.textContent = 'Select & copy';
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(kod).then(bitti, eskiYontem);
    } else {
      eskiYontem();
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lak-kopyala]');
    if (btn) { e.preventDefault(); kopyala(btn); }
  });

  /*
    Slider otomatik döndüğü için "Get early access" linkiyle gelen ya da formu
    dolduran ziyaretçi kampanya slaytından kaydırılmasın: temanın kendi
    'theme:slideshow:selectSlide' olayıyla o slayt seçilir ve autoplay durur.
  */
  function kampanyaSlaydiniTut() {
    var s = document.querySelector('.lak-slayt');
    var gosterici = s && s.closest('slideshow-element');
    if (!gosterici) return;
    var i = Array.prototype.indexOf.call(gosterici.querySelectorAll('[data-slide]'), s);
    if (i < 0) return;
    gosterici.dispatchEvent(new CustomEvent('theme:slideshow:selectSlide', { detail: { index: i } }));
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#la-kampanya"]');
    if (a && document.querySelector('.lak-slayt')) setTimeout(kampanyaSlaydiniTut, 0);
  });
  document.addEventListener('focusin', function (e) {
    if (e.target.closest && e.target.closest('.lak-slayt')) kampanyaSlaydiniTut();
  });

  /*
    Varyant değişimi: tema (product-info.js) yeni varyantın id'sini formdaki
    input[name="id"]'ye yazıp 'change' olayı gönderir. Fiyatı farklı varyantlı
    ürünlerde (9 Eki'de 40 ürün) şeritteki indirimli fiyat bununla güncellenir.
  */
  var varyantFiyatlari = {};
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.name !== 'id' || !input.value || input.type !== 'hidden') return;
    // Yalnız temanın ana ürün formu (product-form-<bölüm>). "Frequently bought
    // together" gibi uygulamaların kendi name="id" seçim kutuları sayılmaz.
    var form = input.form || input.closest('form');
    if (!form || !/^product-form-/.test(form.id) || /installment/.test(form.id)) return;
    var kapsam = input.closest('product-info') || document;
    var kok = kapsam.querySelector('[data-lak="urun"]');
    if (!kok) return;
    var yol = kok.getAttribute('data-lak-redirect');
    var id = input.value;
    function uygula(fiyatlar) {
      if (fiyatlar[id] === undefined) return;
      kok.setAttribute('data-lak-fiyat', fiyatlar[id]);
      doldur(kok, etkin());
    }
    if (varyantFiyatlari[yol]) { uygula(varyantFiyatlari[yol]); return; }
    fetch(yol + '.js').then(function (r) { return r.json(); }).then(function (u) {
      var f = {};
      (u.variants || []).forEach(function (v) { f[String(v.id)] = v.price; });
      varyantFiyatlari[yol] = f;
      uygula(f);
    }).catch(function () {});
  });

  function tik() {
    var d = esitle(false);
    sayaclar(d);
  }

  /*
    Temanın sabit header'ı duyuru barının yüksekliğini --announcement-bar-height
    değişkeninden okur (announcement.js yazar). Duyuru barı gizliyken o değer 0
    olur ve header kampanya barının üstüne biner; bu yüzden değeri bar görünürken
    biz yazarız. announcement.js yeniden boyutlanmada 0 yazdığı için bir tık sonra
    tekrar yazılır.
  */
  function barYuksekligi() {
    var bar = document.querySelector('.lak-bar');
    if (!bar || bar.hidden) return;
    document.documentElement.style.setProperty('--announcement-bar-height', bar.offsetHeight + 'px');
  }
  function barYuksekligiSonra() { setTimeout(barYuksekligi, 60); }

  function basla() {
    esitle(true);
    barYuksekligi();
    window.addEventListener('load', barYuksekligiSonra);
    document.addEventListener('theme:resize:width', barYuksekligiSonra);
    window.addEventListener('resize', barYuksekligiSonra);
    if (window.ResizeObserver) {
      var barEl = document.querySelector('.lak-bar');
      if (barEl) new ResizeObserver(barYuksekligi).observe(barEl);
    }
    sayaclar(etkin());
    setInterval(tik, 1000);
    if (location.hash === '#la-kampanya' || /customer_posted=true/.test(location.search)) {
      // Slider kendini kurduktan sonra
      setTimeout(kampanyaSlaydiniTut, 400);
      window.addEventListener('load', function () { setTimeout(kampanyaSlaydiniTut, 100); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();
